import React from 'react'
import { Table, Text, NumberFormatter } from '@mantine/core'
import dayjs from 'dayjs'

const TableCommisionUser = ({ label, data }) => {
  const mappingTableHead = (data) => data.map((val, index) => {
    return (<Table.Th key={index} width={val.width !== 'auto' ? val.width : ''}>{val.label}</Table.Th>)
  })

  const mappingDataTable = (data) => data.map((val, index) => {
    return (
      <Table.Tr key={index}>
        <Table.Td>{val.date ? dayjs(val.date).format('DD MMMM YYYY') : '-'}</Table.Td>
        <Table.Td tt='capitalize'>{val.commision_for || '-'}</Table.Td>
        <Table.Td tt='capitalize'>{val.agent_or_partner || '-'}</Table.Td>
        <Table.Td>{val.order_code || '-'}</Table.Td>
        <Table.Td>
          <Text fz={13} c='black'>
            <NumberFormatter
              prefix={`${val.currency}. `}
              thousandSeparator=","
              decimalSeparator="."
              decimalScale={2}
              fixedDecimalScale={true}
              value={val.handling_fee || 0} 
            />
          </Text>
        </Table.Td>
        <Table.Td>
          <Text fz={13} c='black'>
            <NumberFormatter
              prefix={`${val.currency}. `}
              thousandSeparator=","
              decimalSeparator="."
              decimalScale={2}
              fixedDecimalScale={true}
              value={val.amount || 0} 
            />
          </Text>
        </Table.Td>
        <Table.Td>{val.payout_id || '-'}</Table.Td>
      </Table.Tr>
    )
  })

  return (
    <Table.ScrollContainer minWidth={1366} type='native'>
      <Table highlightOnHover withTableBorder style={{ fontSize: '13px' }}>
        <Table.Thead style={{ backgroundColor: '#eeefef' }}>
          <Table.Tr>
            {mappingTableHead(label)}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody style={{ verticalAlign: 'top' }}>
          {mappingDataTable(data)}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  )
}

export default TableCommisionUser